import { userSetupSettingsStyles } from "@insite/content-library/Widgets/UserSetup/UserSetupSettings";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import { css } from "styled-components";

userSetupSettingsStyles.title = {
    variant: "h5",
    css: css`
        font-family: ${TYPOGRAPHY.fontFamily.title};
        font-weight: 700;
        color: ${COLORS.text.main};
        font-style: normal;
    `,
};
userSetupSettingsStyles.wrapper = {
    css: css`
        padding-bottom: 15px;
        font-weight: 400;
        font-family: ${TYPOGRAPHY.fontFamily.title};
        div[class^="FormFieldStyle"] {
            label {
                color: ${COLORS.text.main};
            }
        }
    `,
};
